<template>
  <div id="login-wrapper">
    <div id="login-screen-holder">
      <div id="login-screen" class="shadow">
        <img src="../../assets/logo-bird.svg">

        <form v-on:submit.prevent="register">
          <input type="text"
                 v-model="firstName"
                 :placeholder="$t('first-name')"
                 v-on:focus="showWelcomeBird = false"
                 v-on:blur="welcomeBird"
                 v-bind:class="{ error: hasError('firstName') }"
                 class="shadow"/><br/><br/>

          <input type="text"
                 v-model="lastName"
                 :placeholder="$t('last-name')"
                 v-bind:class="{ error: hasError('lastName') }"
                 class="shadow"/><br/><br/>

          <input type="text"
                 v-model="companyName"
                 :placeholder="$t('company-name')"
                 v-bind:class="{ error: hasError('companyName') }"
                 class="shadow"/><br/><br/>

          <input type="text"
                 v-model="email"
                 :placeholder="$t('email')"
                 v-bind:class="{ error: hasError('email') }"
                 class="shadow"/><br/><br/>

          <input type="password"
                 v-model="password"
                 :placeholder="$t('password')"
                 autocomplete="new-password"
                 v-bind:class="{ error: hasError('password') }"
                 class="shadow"/><br/><br/>

          <label for="terms">
            <input id="terms" name="terms" type="checkbox" v-model="terms"/>
            <span>
              <i18n path="agree-terms">
                <a :href="'/files/' + $t('terms-filename')" target="_blank">{{$t('terms')}}</a>
              </i18n>
            </span>
          </label>

          <button class="button button-lg shadow">{{$t('register')}}</button>

          <p v-if="hasError('terms')" class="error">
            {{ $t('terms-error') }}
          </p>
        </form>

        <p><router-link to="/login">{{$t('already-account')}}</router-link>?</p>
      </div>
    </div>

    <talking-bird
      v-if="showWelcomeBird"
      :text="$t('welcome-bird', { name: firstName })">
    </talking-bird>

  </div>
</template>

<script>
export default {
  name: 'Register',

  data() {
    return {
      email: '',
      firstName: '',
      lastName: '',
      companyName: '',
      password: '',
      terms: false,
      errors: [],
      showWelcomeBird: false,
    };
  },

  methods: {
    welcomeBird() {
      if (this.firstName.length > 1) {
        this.showWelcomeBird = true;
      }
    },

    register() {
    },

    checkForm() {
      this.errors = [];

      if (!this.firstName) this.errors.push('firstName');
      if (!this.lastName) this.errors.push('lastName');
      if (!this.companyName) this.errors.push('companyName');
      if (!this.email) this.errors.push('email');
      if (!this.password) this.errors.push('password');
      if (!this.terms) this.errors.push('terms');

      return this.errors.length === 0;
    },

    hasError(field) {
      return this.errors.indexOf(field) > -1;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  #login-wrapper {
    position: fixed;
    width: 100%;
    height: 100%;
    background: url("../../assets/login-bg.svg") no-repeat center;
    background-size: cover;
    padding: 0;
    margin: -35px 0 0  -350px;
    display: table;
  }

  #login-screen-holder {
    display: table-cell;
    vertical-align: middle;
  }

  #login-screen {
    background: white;
    width: 400px;
    padding: 40px 30px;
    margin: auto;
    text-align: center;
    border-radius: 10px;
    font-size: 12px;
  }

  #login-screen img {
    max-width: 60px;
    transform: rotate(45deg);
  }

  #login-screen form {
    padding-top: 40px;
  }

  #login-screen input[type='text'],
  #login-screen input[type='password'] {
    width: 250px;
    padding: 15px 25px;
    border-radius: 5px;
    border: 0;
    outline: 0;
    font-size: 14px;
    font-weight: 400;
    color: #6C6C6C;
  }

  #login-screen input.error {
    border: 1px solid red;
  }

  #login-screen input.error::placeholder {
    color: rgba(255, 0, 0, 0.6);
  }

  p.error {
    color: rgba(255, 0, 0, 0.6);
  }

  #login-screen input::placeholder {
    color: #BFD0FF;
  }

  #login-screen label {
    padding-bottom: 30px;
    padding-top: 20px;
    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
    -khtml-user-select: none; /* Konqueror HTML */
    -moz-user-select: none; /* Firefox */
    -ms-user-select: none; /* Internet Explorer/Edge */
    user-select: none;
  }

  #login-screen button {
    width: 300px;
    padding: 15px 40px;
  }

  #login-screen p {
    margin-top: 50px;
    font-size: 12px;
    margin-bottom: -20px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/authentication/Register.vue